export default "__VITE_ASSET__Bx3sDd$D__"